/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'level': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75 118l38.289-25.078L99.609 84l13.68-9-13.68-9 13.68-9L75 32 36.711 57.078l13.68 9L36.711 75l13.68 9-13.68 9L75 118zM44 57.078l31-20.301 31 20.301-31 20.301-31-20.301zM44 75l10-6.57 21 13.73 21-13.73L106 75 75 95.301 44 75zm10 11.352l21 13.727 21-13.727 10 6.57-31 20.31-31-20.31 10-6.57z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
